import { UserCircle2 } from "lucide-react";

export function CreatedByNote({ record }) {
  if (!record?.created_by_name && !record?.created_at) return null;
  const when = record.created_at
    ? new Date(record.created_at).toLocaleString("en-AU", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false })
    : "";
  return (
    <p className="flex items-center gap-1 self-center text-[11px] text-slate-400 sm:mr-auto" data-testid="created-by-note">
      <UserCircle2 className="h-3 w-3" /> Created by {record.created_by_name?.split(" ")[0] || "Unknown"}{when ? ` · ${when}` : ""}
    </p>
  );
}
